import { render, staticRenderFns } from "./AddressBookLayout.vue?vue&type=template&id=17639147&scoped=true&"
import script from "./AddressBookLayout.vue?vue&type=script&lang=js&"
export * from "./AddressBookLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17639147",
  null
  
)

export default component.exports